import React from 'react'
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown'

const POPULAR_STYLES = [
  { text: 'MLA8', key: 'mla8' },
  { text: 'MLA7', key: 'mla7' },
  { text: 'APA', key: 'apa' },
  { text: 'Chicago', key: 'chicagob' },
]

const StyleSelect = ({selected, onChange}) =>
  <Dropdown
    placeHolder='Select a Style'
    ariaLabel='Style'
    id='Basicdrop2'
    options={ POPULAR_STYLES }
    selectedKey={ selected }
    onChanged={option => onChange(option.key)}
  />

  export default StyleSelect



// WEBPACK FOOTER //
// ./src/StyleSelect.js